
export default {
    page: {
        tab01: { enable: false },
        tab02: { enable: false },
        tab03: { enable: false },
        tab04: {
            enable: false,
            tooltip: {
                on: false,
                msg: 'botApp.p2.inReview.page.tab04.tooltip.msg'
            }
        },
        tab05: { enable: false }
    },
    button: {
        save: {
            show: false,
            enable: false,
            label: 'botApp.p2.inReview.button.save.label',
            dialog: {
                title: 'botApp.p2.inReview.button.save.dialog.title',
                msg: 'botApp.p2.inReview.button.save.dialog.msg',
                ok: 'botApp.p2.inReview.button.save.dialog.ok',
                cancel:
                    'botApp.p2.inReview.button.save.dialog.cancel',
                method: 'post',
                apiUrl: 'developer/deploy/app/{0}',
                withBody: true
            },
            rep_dialog: {
                title:
                    'botApp.p2.inReview.button.save.rep_dialog.title',
                msg: 'botApp.p2.inReview.button.save.rep_dialog.msg'
            }
        },
        submit: {
            show: false,
            enable: true,
            label: 'botApp.p2.inReview.button.submit.label',
            dialog: {
                title:
                    'botApp.p2.inReview.button.submit.dialog.title',
                msg: 'botApp.p2.inReview.button.submit.dialog.msg',
                ok: 'botApp.p2.inReview.button.submit.dialog.ok',
                cancel:
                    'botApp.p2.inReview.button.submit.dialog.cancel',
                method: 'post',
                apiUrl: 'developer/for/review/app/{0}',
                withBody: true
            },
            rep_dialog: {
                title:
                    'botApp.p2.inReview.button.submit.rep_dialog.title',
                msg: 'botApp.p2.inReview.button.submit.rep_dialog.msg'
            }
        },
        devReject: {
            show: true,
            enable: true,
            label: 'botApp.p2.inReview.button.devReject.label',
            dialog: {
                title:
                    'botApp.p2.inReview.button.devReject.dialog.title',
                msg: 'botApp.p2.inReview.button.devReject.dialog.msg',
                ok: 'botApp.p2.inReview.button.devReject.dialog.ok',
                cancel:
                    'botApp.p2.inReview.button.devReject.dialog.cancel',
                method: 'post',
                apiUrl: 'developer/reject/app/{0}',
                withBody: false
            },
            rep_dialog: {
                title:
                    'botApp.p2.inReview.button.devReject.rep_dialog.title',
                msg:
                    'botApp.p2.inReview.button.devReject.rep_dialog.msg'
            }
        },
        newAPK: {
            show: true,
            enable: false,
            label: 'botApp.p2.inReview.button.newAPK.label',
            dialog: {
                title:
                    'botApp.p2.inReview.button.newAPK.dialog.title',
                msg: 'botApp.p2.inReview.button.newAPK.dialog.msg',
                ok: 'botApp.p2.inReview.button.newAPK.dialog.ok',
                cancel:
                    'botApp.p2.inReview.button.newAPK.dialog.cancel',
                method: 'post',
                apiUrl: 'developer/deploy/app/{0}',
                withBody: false
            },
            rep_dialog: {
                title:
                    'botApp.p2.inReview.button.newAPK.rep_dialog.title',
                msg: 'botApp.p2.inReview.button.newAPK.rep_dialog.msg'
            }
        },
        discardAPK: {
            show: false,
            enable: false,
            label: 'botApp.p2.inReview.button.discardAPK.label',
            dialog: {
                title:
                    'botApp.p2.inReview.button.discardAPK.dialog.title',
                msg:
                    'botApp.p2.inReview.button.discardAPK.dialog.msg',
                ok: 'botApp.p2.inReview.button.discardAPK.dialog.ok',
                cancel:
                    'botApp.p2.inReview.button.discardAPK.dialog.cancel',
                method: 'post',
                apiUrl: 'developer/deploy/app/{0}',
                withBody: true
            },
            rep_dialog: {
                title:
                    'botApp.p2.inReview.button.discardAPK.rep_dialog.title',
                msg:
                    'botApp.p2.inReview.button.discardAPK.rep_dialog.msg'
            }
        },
        publish: {
            show: false,
            enable: true,
            label: 'botApp.p2.inReview.button.publish.label',
            dialog: {
                title:
                    'botApp.p2.inReview.button.publish.dialog.title',
                msg: 'botApp.p2.inReview.button.publish.dialog.msg',
                ok: 'botApp.p2.inReview.button.publish.dialog.ok',
                cancel:
                    'botApp.p2.inReview.button.publish.dialog.cancel',
                method: 'post',
                apiUrl: 'developer/publish/app/{0}',
                withBody: false
            },
            rep_dialog: {
                title:
                    'botApp.p2.inReview.button.publish.rep_dialog.title',
                msg:
                    'botApp.p2.inReview.button.publish.rep_dialog.msg'
            }
        },
        unpublish: {
            show: true,
            enable: true,
            dialog: {
                title:
                    'botApp.p2.inReview.button.unpublish.dialog.title',
                msg: 'botApp.p2.inReview.button.unpublish.dialog.msg',
                ok: 'botApp.p2.inReview.button.unpublish.dialog.ok',
                cancel:
                    'botApp.p2.inReview.button.unpublish.dialog.cancel',
                method: 'post',
                apiUrl: 'developer/unpublish/app/{0}',
                withBody: false
            },
            rep_dialog: {
                title:
                    'botApp.p2.inReview.button.unpublish.rep_dialog.title',
                msg:
                    'botApp.p2.inReview.button.unpublish.rep_dialog.msg'
            }
        }
    },
    storeCtrl: { show: true, enable: false },
    leaveAlert: {
        enable: false,
        dialog: {
            title: 'botApp.p2.inReview.leaveAlert.dialog.title',
            msg: 'botApp.p2.inReview.leaveAlert.dialog.msg',
            ok: 'botApp.p2.inReview.leaveAlert.dialog.ok',
            cancel: 'botApp.p2.inReview.leaveAlert.dialog.cancel'
        }
    }
}
